import { takeLatest } from 'redux-saga/effects';
import { createAppTableSaga, createAppTableStore, createPersist } from 'components/AppTable/store';
import apiRoutes from 'config/apiRoute';
import { convertMinsToHrsMins } from 'utils/string.utils';
import { requestSlice } from './request';

export const requestExportSlice = createAppTableStore({
  name: 'tableRequestsExport' as const,
  url: apiRoutes.REQUESTS,
  initialState: {
    ...requestSlice.getInitialState(),
    fixedParams: {
      ...requestSlice.getInitialState().fixedParams,
      with: 'project_time,latest_comment,tasks',
    },
    paramFilterFields: {
      ...requestSlice.getInitialState().paramFilterFields,
      'projects_requests.temperature': 'filters[projects_requests.temperature][]',
    },
  },
  reducers: {
    setTotalTime: requestSlice.caseReducers.setTotalTime,
    setCountPerTemp: requestSlice.caseReducers.setCountPerTemp,
  },
});

function* handleApiResponseSagaListener({ payload }: { payload: any }) {
  yield requestExportSlice.actions.setTotalTime(convertMinsToHrsMins(Number(payload.total_time)));
  yield requestExportSlice.actions.setCountPerTemp(payload.count_per_temp);
}

export const requestsExportSaga = createAppTableSaga(requestExportSlice, function* customGenerator() {
  yield takeLatest(requestExportSlice.actions.handleApiResponse, handleApiResponseSagaListener);
});

export const requestExportReducer = createPersist(requestExportSlice);
